var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$route.meta && this.$route.meta.layout)?_c(this.$route.meta.layout,{tag:"component"}):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }